import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Flexer } from '@ontruck/orc';
import moment from 'moment-timezone';

class WeekDays extends PureComponent {
  getShortWeekDays() {
    const { schedule } = this.props;
    return Array.from(Array(7), (_, x) => x + 1).map((isoDay) => ({
      name: isoDay,
      label: moment.weekdaysShort(isoDay),
      checked: schedule.includes(isoDay),
    }));
  }

  render() {
    const { onChange, disabled } = this.props;
    return (
      <Flexer.Parent>
        {this.getShortWeekDays().map((day) => (
          <Flexer.Child mRight="S">
            <Checkbox
              key={day.name}
              name={day.name}
              label={day.label}
              checked={day.checked}
              size="M"
              girded
              onChange={onChange}
              disabled={disabled}
            />
          </Flexer.Child>
        ))}
      </Flexer.Parent>
    );
  }
}

WeekDays.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

WeekDays.defaultProps = {
  onChange: () => {
    /*noop*/
  },
  disabled: true,
};

export default WeekDays;
